function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2 13l9.28-10L21 13",
  stroke: "#fff",
  strokeWidth: 3
});

var SvgArrowTop = function SvgArrowTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "10%",
    viewBox: "0 0 23 15",
    fill: "none"
  }, props), _ref);
};

export default SvgArrowTop;